import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import OfflineAdvantages from './components/OfflineAdvantages';
import FeatureChecklist from './components/FeatureChecklist';
import PricingSection from './components/PricingSection';
import PricingComparison from './components/PricingComparison';
import TechnicalRequirements from './components/TechnicalRequirements';
import SyncCapabilities from './components/SyncCapabilities';
import DownloadSection from './components/DownloadSection';
import CTASection from './components/CTASection';

const DesktopApp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // desktop license calculator removed per request

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Desktop POS - Cultaz | Offline Retail Software for Nigerian Businesses</title>
        <meta name="description" content="Cultaz Desktop POS: fast, reliable offline point-of-sale with local inventory, receipts, and monthly licensing. Works without internet. Perfect for Nigerian retailers. Download now." />
        <meta name="keywords" content="desktop POS, offline POS, retail software desktop, point of sale software, offline retail management, Nigeria POS system, desktop retail software, local inventory management" />
        <meta name="author" content="Cultaz" />
        <meta property="og:title" content="Desktop POS - Cultaz | Offline Retail Software" />
        <meta property="og:description" content="Fast, reliable offline POS - local storage, receipt printing, inventory management. Works without internet. Perfect for Nigerian retailers." />
        <meta property="og:image" content="https://cultaz.com/banners/1.png" />
        <meta property="og:url" content="https://cultaz.com/desktop-app" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Cultaz" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Desktop POS - Cultaz | Offline Retail Software" />
        <meta name="twitter:description" content="Fast, reliable offline POS - local storage, receipt printing, inventory. Works without internet." />
        <meta name="twitter:image" content="https://cultaz.com/banners/1.png" />
        <link rel="canonical" href="https://cultaz.com/desktop-app" />
      </Helmet>
      <Header />
      
      <main>
        <HeroSection />
        <OfflineAdvantages />
        <FeatureChecklist />
        <SyncCapabilities />
        <div className="container mx-auto px-4 py-8">
          <h2 className="text-2xl font-bold mb-4">Desktop licensing & pricing</h2>
          <PricingComparison desktopPrice={0} />
        </div>
        <PricingSection />
        <TechnicalRequirements />
        <DownloadSection />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
};

export default DesktopApp;